export async function downloadRemoteFile(
  url: string,
  filename: string
): Promise<void> {
  if (!url) return

  try {
    const res = await fetch(url, { mode: 'cors', credentials: 'omit' })
    if (!res.ok) throw new Error(String(res.status))
    const blob = await res.blob()
    const objectUrl = URL.createObjectURL(blob)
    try {
      const a = document.createElement('a')
      a.href = objectUrl
      a.download = filename || 'download'
      a.rel = 'noopener'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    } finally {
      URL.revokeObjectURL(objectUrl)
    }
  } catch {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}
